export default {
    //Splash
    splash_message: 'Əlaqə və təlim platforması',

    //TTCC
    accept_ttcc: 'İstifadə Şərtlərini Kabul Et',

    //Login
    welcome: 'Xoş gəlmisiniz!',
    welcome_message: 'Dots, əlaqə və təlim üçün yeni texnologiyalı müttəfiqliniz.',
    username: 'İstifadəçi adı',
    password: 'Parol',
    code: 'Kod',
    recover_password: 'Parolu bərpa edin',
    log_in: 'Giriş',
    log_in_biometrics: 'Biometrik məlumatlarla daxil olun',
    create_user: 'İstifadəçi yarat',
    recover_access_to_account: 'Hesabınıza girişi bərpa etmək üçün istifadəçi adınızı daxil edin',
    back: 'Geri',
    enter_new_password: 'Kodu və yeni parolunuzu daxil edin',
    enter_code: 'Kodu daxil edin',
    new_password: 'Yeni parol',
    repeat_new_password: 'Yeni parolu təkrarlayın',
    validate: 'Təsdiq edin',
    complete_all_fields: 'Bütün sahələri doldurun',
    passwords_do_not_match: 'Parollar uyğun gəlmir',
    user_created_successfully: 'İstifadəçi uğurla yaradıldı',
    create_user: 'İstifadəçi yarat',
    required_fields: 'Tələb olunan sahələr',
    confirm_your_email: 'E-poçtunuzu təsdiq edin',
    confirm_your_phone: 'Telefonunuzu təsdiqləyin',
    confirm_password: 'Parolu təsdiq edin',
    modifying_email: 'E-poçt ünvanınızı dəyişirsiniz',
    validate_code: 'Kodu təsdiq edin',
    code_sent_successfully: 'Kod uğurla göndərildi',
    password_reset: 'Parolunuz uğurla yeniləndi',
    enter_confirmation_code: 'Təsdiq kodunuzu daxil edin',
    enter_your_new_email: 'Yeni e-poçtunuzu daxil edin',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Ой! Біз сіздің есептік жазбаңызды таба алмадық',
    contact_the_administrator: 'Сіз енгізген пайдаланушы жоқ сияқты.\nОның дұрыс жазылғанына көз жеткізіңіз\nнемесе әкімшімен хабарласыңыз.',
    invalid_user_or_pass: 'İstifadəçi adı və/və ya şifrə yanlışdır',
    info_is_not_correct: 'Məlumatlardan bəziləri düzgün deyil, zəhmət olmasa yenidən cəhd edin.',
    enter_user: 'Zəhmət olmasa, istifadəçi adı daxil edin',
    nonexistent_user: 'İstifadəçi mövcud deyil. Zəhmət olmasa, yenidən cəhd edin.',
    incorrect_code: 'Yanlış kod',
    change_saved_successfully: 'Dəyişiklik uğurla yadda saxlanıldı',
    pass_changed_successfully: 'Şifrə uğurla dəyişdirildi',
    check_your_email: 'Doğrulama kodunu daxil etmək üçün e-poçtunuzu yoxlayın',
    eight_characters: '*8 simvoldan çox olmalıdır',
    one_uppercase_letter: '*Ən azı 1 böyük hərf olmalıdır',
    one_special_character: '*Ən azı 1 xüsusi simvol olmalıdır (@,$,!,#,?)',
    pass_requirements:
        'Aşağıdakı tələblərə cavab verməlidir:\n\n*8 simvoldan çox olmalıdır\n*Ən azı 1 böyük hərf olmalıdır\n*Ən azı 1 xüsusi simvol olmalıdır (məsələn: $, !, #, ?)',
    select_date: 'Tarix seçin',
    cannot_create_password: 'Şifrə yaradıla bilməz',
    complete_your_details: 'Davam etmək üçün məlumatlarınızı tamamlayın',
    enter_valid_number: 'Düzgün nömrə daxil etməlisiniz',
    complete_numbers:
        'Son nömrənin cəmi 13 rəqəm olması üçün "15" prefiksini silmək lazımdır, məsələn: +54 9 XXX XXX XXXX, qalan 10 rəqəmi tamamlamalısınız.',

    //Profile
    insufficient_permissions: 'Yetərsiz icazələr',
    permissions_are_required: 'Kamera və fotoqalereyə giriş üçün icazələr tələb olunur.',
    choose_font: 'Mənbə seçin',
    where_do_you_want: 'Şəkil seçmək istədiyiniz yer nədir?',
    camera: 'Kamera',
    gallery: 'Qalereya',
    edit_photo: 'Şəkli redaktə edin',
    cancel: 'Ləğv edin',
    save: 'Saxlayın',
    app: 'Tətbiq',
    support: 'Dəstək',
    other: 'Digər',
    contact_channel: 'Əlaqə kanalı',
    select_the_contact_channel: 'Əlaqə kanalını seçin',
    subject: 'Mövzu',
    write_the_subject: 'Mövzunu yazın',
    message: 'Mesaj',
    write_a_comment: 'Şərh yazın',
    send: 'Göndər',
    sent_successfully: 'Uğurla göndərildi',
    thank_you_for_leaving_us_your_comments: 'Şərhlərinizi bizə təqdim etdiyiniz üçün təşəkkür edirik, tezliklə sizinlə əlaqə saxlanılacaq.',
    close: 'Bağla',
    check_for_update: 'Yeniləmələri yoxlayın',
    clear_cache: 'Kesini təmizlə',
    delete_account: 'Hesabı sil',
    log_out: 'Çıxış',
    notifications: 'Bildirişlər',
    insufficient_permissions: 'Yetərsiz icazələr',
    permissions_to_access: 'Kamera və fotoqalereyə giriş üçün icazələr tələb olunur.',
    choose_font: 'Mənbə seçin',
    select_the_image: 'Şəkli haradan seçmək istəyirsiniz?',
    change_language: 'Dili dəyişdirin',
    change_language_title: 'Vacibdir!',
    change_language_message:
        'Bu hərəkəti yerinə yetirmək üçün internet bağlantısı lazımdır. Bu, oflayn istifadə üçün endirilmiş məzmunu siləcək. Nəzərə alın ki, dəyişiklik cihazınızın dilindən asılı olaraq tətbiqin strukturuna deyil, yalnız proqramın məzmununa təsir edəcək.',
    logout_not_available: 'Çıxış mümkün deyil',
    cant_logout: 'Hazırda internet bağlantınız olmadığı üçün çıxış edə bilməzsiniz. Zəhmət olmasa, bağlantınızı yoxlayın və yenidən cəhd edin.',
    //nuevos al 01-08-2024
    cache_cleared: 'Keş uğurla təmizləndi',
    deletes_the_content:
        'Bu əməliyyat oflayn rejimdə tətbiqin istifadəsi üçün endirilmiş məzmunu silir. Baxmağa davam etmək üçün qoşulduğunuzdan əmin olun.',
    error_uploading_image: 'Şəkil yüklənərkən xəta baş verdi: ',
    there_was_an_error: 'Şəkil yüklənərkən xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin.',
    //nuevos al 21-11-2024
    email: 'E-poçt',
    phone: 'Telefon',
    name: 'Ad',
    last_name: 'Soyad',
    role: 'Vəzifə',
    verify: 'Təsdiqlə',
    verified: 'Təsdiqləndi',
    contact_channels: 'Əlaqə kanalları',
    editing_your_email: 'E-poçtunuzu redaktə edirsiniz',
    editing_your_phone: 'Telefon nömrənizi redaktə edirsiniz',
    modifying_your_email:
        'E-poçtunuzu dəyişirsiniz, daxil etməyiniz üçün e-poçtunuza bir kod göndəriləcək. Əgər hələ də kodu almadınızsa, yenidən yoxlayın.',
    modifying_your_phone:
        'Mobil nömrənizi dəyişirsiniz, daxil etməyiniz üçün SMS vasitəsilə bir kod alacaqsınız. Əgər hələ də kodu almadınızsa, yenidən yoxlayın.',

    //Notifications
    all: 'Bütün',
    unread: 'Oxunmamış',
    read: 'Oxunmuş',
    seen: 'Görülüb',
    notifications: 'Bildirişlər',
    here_you_will_find: 'Burada bütün xəbərdarlıqları və bildirişləri tapa bilərsiniz!',
    mark_all_read: 'Hamısını oxunmuş kimi işarələ',
    you_have_no_notifications: 'Sizin heç bir bildirişiniz yoxdur!',
    you_will_soon_start: 'Tezliklə yeni kommunikasiya almaya başlayacaqsınız',

    //Buscador
    enter_your_search: 'Axtarışınızı daxil edin',
    no_results: 'Nəticə tapılmadı',
    search_content: 'Sizi maraqlandıran məzmunu axtarın.',
    see: 'Görün',
    results_in: 'nəticə',
    see_less_results: 'Az nəticələri görün',
    all: 'Bütün',
    wall: 'Divaan',
    learning: 'Öyrənmə',
    benefits: 'Faydalar',
    portfolio: 'Portfel',
    retry: 'Yenidən cəhd edin',
    locked: 'Kilidlənmiş',
    pending: 'Gözləyən',
    seen: 'Görülüb',
    approved: 'Təsdiqlənmiş',

    //Posts
    see_them: 'Hamısını baxın ',
    _comments: ' şərh',
    reactions_from_other_users: 'Digər istifadəçilərdən reaksiyalar',
    not_connected_to_the_network: 'Şəbəkəyə qoşulmadınız',
    comment: 'Şərh',
    comments: 'Şərhlər',
    write_a_comment: 'Şərh yazın',
    no_content: 'Məzmun yoxdur',
    reaction: 'Reaksiya',
    reactions: 'Reaksiyalar',
    first_comment: 'Birinci şərh yazan siz olun!',
    no_comment: 'Hələ ki bu məqaləyə heç bir şərh yoxdur.',
    write_a_comment: 'Şərh yazın',
    no_publications: 'Heç bir yayımlanmış məzmun yoxdur',
    no_post_to_read: 'Oxumaq üçün heç bir məqaləniz yoxdur.',
    views: 'baxışlar',
    reply: 'Cavab verin',
    see: 'Görün ',
    more_answers: 'daha çox cavab',
    hide: 'Gizlə',
    answers: ' cavablar',
    no_reactions: 'Hələlik reaksiyalar yoxdur!',
    leave_your_reaction: 'Birinci reaksiyanızı buraxın.',
    //nuevos al 01-08-2024
    full_survey: 'Sorğunu tamamladınız!',
    thanks_for_participating: 'İştirak etdiyiniz üçün təşəkkür edirik! Daha çox yeniləmə üçün divara baxın.',
    sent_automatically: 'Bağlantınız bərpa olunanda avtomatik olaraq göndəriləcək.',
    no_post_saved: 'Hələ saxlanmış paylaşım yoxdur',
    see_your_favorite_content: 'Burada sevdiyiniz məzmunu görəcəksiniz.',
    //fechas
    instant: 'Bir neçə dəqiqə əvvəl',
    hourFirst: 'Öncə ',
    hour: ' saat',
    hours: ' saat',
    day: ' gün',
    days: ' gün',

    //Learning
    congratulations: 'Təbrik edirik!',
    you_approved: 'Siz keçdiniz ',
    you_completed: 'Siz bu kursu başa çatdırdınız',
    you_disapproved: 'Qeyri-müəyyən qiymətləndirmə',
    score: 'Qiymət:',
    return_to_course: 'Evə qayıdın',
    retry: 'Yenidən cəhd edin',
    it_is_available: 'İndi mövcuddur',
    total_course_evaluation: 'Ümumi kurs qiymətləndirməsi',
    evaluate_me: 'MƏNI QIYMAET EDIN',
    completed_the_course: 'Siz kursu başa çatdırdınız',
    pending_approval: 'Təsdiq gözləyir',
    return: 'Geri qayıdın',
    continue_course: 'Kursa davam edin',
    you_have_made: 'Siz başa çatdınız ',
    of_the_course: ' kursdan',
    locked: 'kilidlənmiş',
    pending: 'gözləyən',
    seen: 'görülüb',
    complete: 'tamamlandı',
    reprobate: 'çatmamaq',
    sync_pend: 'sinx pend.',
    in_progress: 'in progress',
    perform_evaluation: 'Qiymətləndirməni yerinə yetirin',
    next_content: 'Növbəti məzmun',
    you_completed_all: 'Siz bütün məzmunları başa çatdırdınız',
    final_evaluation: 'NƏTİCƏLƏNDİRİLƏN QİYMƏT',
    retry_mayus: 'YENİDƏN CƏHD EDİN',
    see_more: '...daha',
    see_less: '...az',
    back_to_course: 'KURSA GERİ QAYIDIN',
    click_to_see: 'Görmək üçün klikləyin',

    //Evaluaciones
    evaluation: 'Qiymətləndirilmə: ',
    of: ' of ',
    loading_evaluation: 'Qiymətləndirmə yüklənir...',
    select_option: 'Davam etmək üçün bir variant seçməlisiniz',
    select_one_answer: 'Hər sual üçün ən az bir cavab seçməlisiniz.',
    exit_evaluation: 'Qiymətləndirmədən çıxmaq istəyirsinizmi?',
    your_answers_will_not_be_saved: 'Əgər indi çıxarsanız, cavablarınız qeyd olunmayacaq',
    continue_evaluation: 'Qiymətləndirməyə davam edin',
    leave_anyway: 'Hər halda tərk edin',
    try_again: 'Yenidən cəhd edin!',
    passed_the_evaluation: 'Siz qiymətləndirməni keçdiniz',
    start_the_course_again: 'Siz qiymətləndirməni keçə bilmədiniz. Keçmək üçün kursu yenidən başladın.',
    evaluation_pending_approval: 'Təsdiq gözləyən qiymətləndirmə',
    notification_result_evaluation: 'Qiymətləndirmənin nəticəsi ilə bağlı tezliklə xəbərdarlıq alacaqsınız',
    write_here: 'Buraya yazın...',
    close: 'Bağla',
    confirm: 'Təsdiq edin',
    sync_pending: 'Sync gözləyən',
    view_certificate: 'Sertifikat baxın',
    // nuevos al 27-01-2025
    course_download_in_process: 'Kurs yüklənir',
    course_is_downloading:
        'Zəhmət olmasa bir neçə saniyə gözləyin. Kurs yüklənir, beləliklə bütün məzmunu offline olaraq rahat şəkildə əldə edə biləcəksiniz.',
    downloaded_course: 'Kurs uğurla endirildi',
    you_can_train_offline: 'Tamam! İndi offline olaraq təlim keçə bilərsiniz.',
    delete_offline_course: 'Bu kursun offline yükləməsini silmək istəyirsiniz?',
    not_view_course_offline: 'Bu kursu offline rejimində görə bilməyəcəksiniz.',
    course_is_not_available: 'Kurs artıq mövcud deyil...',
    not_available_offline: 'Bu kurs artıq offline olaraq mövcud deyil, amma lazım olduqda yenidən yükləyə bilərsiniz.',
    content_download_in_process: 'Məzmun yüklənir',
    content_is_downloading:
        'Zəhmət olmasa bir neçə saniyə gözləyin. Məzmun yüklənir, beləliklə bütün məzmunu offline olaraq rahat şəkildə əldə edə biləcəksiniz.',
    downloaded_content: 'Məzmun uğurla endirildi',
    delete_offline_content: 'Offline məzmunu silmək istəyirsiniz?',
    not_view_content_offline: 'Silindikdə, offline olaraq məzmuna daxil ola bilməyəcəksiniz.',
    content_is_not_available: 'Məzmun artıq mövcud deyil...',
    download_offline: 'Offline yüklə',
    available_offline: 'Offline mövcuddur',
    delete: 'Sil',

    //Stores
    your_progress_in_stores: 'Mağazalardakı irəliləyiniz',
    map: 'Xəritə',
    daily_survey: 'Gündəlik sorğu',
    survey: 'Sorğu',
    matutino: 'SABAHI',
    vespertino: 'AXŞAM',
    form: 'Forma',
    enter_a_number: 'Bir rəqəm daxil edin',
    campaign_expiration: 'KAMPANİYA BİTMƏ TARİXİ: ',
    store_indicators: 'Mağaza göstəriciləri',
    last_days: 'Son 30 günə aid',
    main_indicators: 'Mağaza əsas göstəricilərinin irəliləyişi haqqında məlumat',
    store_information: 'Mükəmməl Mağaza səviyyələrini təmin etmək üçün əhəmiyyətli mağaza məlumatını tapın',
    perform_executions: 'Mağaza statusunu bilmək üçün aşağıdakı təlimatları yerinə yetirin',
    pending_mayus: 'GÖZLƏYƏN',
    approved_mayus: 'TƏSDİQLƏNİB',
    in_review_mayus: 'BƏYANATDA',
    redo_mayus: 'YENİDƏN',
    visited_mayus: 'ZİYARƏT',
    moderation_mayus: 'MODERASİYA',
    review_mayus: 'TƏHLİL',
    in_progress_mayus: 'İŞLƏNİR',
    sync_pend_mayus: 'SYNC GÖZLƏYƏN',
    locked_mayus: 'KİLİTLENMİŞ',
    complete_mayus: 'TAM',
    perfect_store: 'Mükəmməl Mağaza',
    execution: 'Təlimat',
    vouchers: 'Qaimə',
    send: 'Göndər',
    requires: 'Tələb olunur ',
    variation: 'Varyant',
    validity: 'Etibarlıdır: ',
    points: 'bal',
    voucher_canceled: 'Qeyri-aktiv Voucher',
    you_can_try_again: 'Narahat olmayın! Bir daha cəhd edə bilərsiniz.',
    voucher_successful: 'Uğurlu voucher',
    successful_promo: 'Promo uğurla həyata keçirildi!',
    voucher_pending: 'Voucher gözləyir',
    wait_for_the_validation: 'Voucherinizin təsdiq edilməsini gözləyin',
    your_code_is_being_scanned: 'Kodunuz skan edilir ⏳',
    view_qr: 'QR kodu görün',
    return_to_store: 'Mağazaya qayıdın',
    stores_objective: 'Mağazaların məqsədini qarşılamalıdır.',
    welcome_stores: 'Biz mağazalara xoş gəlmisiniz!',
    tip_day:
        'Burada gününüzün mağazalarını ziyarət edə bilərsiniz, müvafiq sorğularınızı yerinə yetirə bilərsiniz və irəliləyinizi nəzərdən keçirə bilərsiniz.',
    close_mayus: 'BAĞLA',
    select_form: 'Başlamaq üçün forma seçin',
    select_one_form: 'Sorğuya başlamaq üçün formlardan birini seçməlisiniz.',
    answer_all_questions: 'Davam etmək üçün bütün sualları cavablandırın.',
    schedule_not_found: 'Bu günün təqvim tapılmadı.',
    form_not_found: 'Təqvimdə forma tapılmadı.',
    send: 'Göndər',
    check_in: 'Giriş',
    check_out: 'Çıxış',
    check_out_done: 'Çıxış tamamlandı',
    off_route: 'Siz yoldan çıxdınız, geri dönmək üçün buraya daxil olun',
    search_barcode: 'Barkodu axtarın',
    no_agenda_today: 'Bu gün üçün heç bir təqviminiz yoxdur!',
    no_agenda_week: 'Bu həftə üçün heç bir təqviminiz yoxdur!',
    no_information_today: 'Bu tarix üçün təqviminiz yoxdur, əgər sualınız varsa, üzv müşavirinizə müraciət edin.',
    no_information_week: 'İstifadəçi üçün məlumat qəbul etmirik, əgər sualınız varsa, üzv müşavirinizə müraciət edin.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'Kamera icazələriniz yoxdur',
    activate_from_settings: 'Davam etmək üçün bunu cihazınızın parametrlərindən aktiv edin.',
    modify_permissions: 'İcazələri dəyişdir',
    complete_fields: 'Bir mağaza yaratmaq üçün aşağıdakı sahələri doldurun',
    create: 'Yarat',
    store_name: 'Mağazanın adı',
    enter_store_name: 'Mağazanın adını daxil edin',
    sore_address: 'Ünvan',
    enter_sore_address: 'Mağazanın ünvanını daxil edin',
    cluster: 'Klüster',
    store_phone: 'Telefon',
    enter_sore_phone: 'Mağazanın telefonunu daxil edin',
    activate_survey: '1.1 Vespertino sorğusunu aktivləşdirmək üçün mağaza hədəflərini tamamlamaq lazımdır. Hədəflər: ',
    inactive_vespertino: 'Vespertino aktiv deyil',
    active_vespertino: 'Vespertino aktiv',
    completed_your_mandatory_objectives: 'Günün məcburi hədəflərini tamamladınız, indi Vespertino-nuzu həyata keçirə bilərsiniz.',
    complete_now: 'İndi tamamlayın',
    perform_later: 'Sonra edin',
    back_to_your_agenda: 'Gününüzün cədvəlinə qayıtmaq istəyirsinizmi?',
    return_to_the_current_day: 'Öncəki günlərin fəaliyyətlərini görürsünüz, davam et düyməsinə toxunsanız, cari günə qayıdacaqsınız: ',
    continue: 'Davam et',
    reached_your_goal: 'Hədəfinizə çatdınız!',
    search_by_barcode: 'Barkodla axtarın',
    scan_the_barcode: 'Bu sorğu siyahısındakı hər hansı bir məhsulun barkodunu skan edin.',
    return_to_form: 'Formaya qayıt',
    product_not_found: 'Məhsul tapılmadı',
    code_does_not_match: 'Kod bu forma ilə əlaqəli heç bir məhsul ilə uyğun gəlmir.',
    search_another_product: 'Başqa məhsul axtarın',
    form_submitted_successfully: ' uğurlu olmuşdur!',
    send_new_survey: 'İstəsəniz, yeni bir sorğu göndərə bilərsiniz.',
    no_agenda_for_today: 'Bu gün üçün gündəm yoxdur!',
    consult_your_supervisor: 'Bu tarix üçün gündəminiz yoxdur, hər hansı bir sualınız varsa, nəzarətçinizlə əlaqə saxlayın.',
    visiting_your_store: 'Siz mağazanızı ziyarət edirsiniz ',
    you_can_check_out: 'Sorğunu tamamlamadan çıxış edə bilərsiniz: ',
    you_met_the_goal: 'Siz məqsədə çatdınız, formu doldurmağa ehtiyac yoxdur.',
    you_must_complete_the_survey: 'Çıxış etmək üçün sorğunu tamamlamalısınız: ',
    checkin_blocked: 'Giriş bloklandı',
    close_the_open_checkin: 'Davam etmək üçün açıq girişi bağlamalısınız.',
    close_the_checkin_opened_in: 'Davam etmək üçün burada açılmış girişi bağlamalısınız: ',
    checkin_out_of_range: 'Giriş diapazondan kənardır',
    more_meters_from_the_store: 'Siz mağazadan 150 metrdən çox məsafədəsiniz.',
    now_is_your_turn: 'İndi sizin növbənizdir!',
    surveys_in_progress: 'Sizin davam edən sorğularınız var: ',
    unfinished_surveys: 'Sizin tamamlanmamış sorğularınız var: ',
    want_to_checkout: 'Çıxış etmək istədiyinizə əminsiniz?',
    selected_store: 'Seçilmiş mağaza',
    checkout_blocked: 'Çıxış bloklandı',
    uncompleted_forms: 'Sizin tamamlanmamış formalarınız var!',
    checkout_anyway: 'Hər halda çıxış etmək istəyirsiniz?',
    go_to_survey: 'Sorğuya keç',
    take_the_survey: 'İndi sorğunu tamamlaya bilərsiniz!',
    validity: 'Keçərlilik: ',
    search_store: 'Mağaza axtar...',
    no_results_for_your_search: 'Axtarışınıza uyğun nəticə tapılmadı',
    find_another_store: 'Başqa mağaza axtarın',
    //nuevos al 21-11-2024
    loading: 'Yüklənir...',
    error_getting_data: 'Məlumat əldə edilmədi.',
    no_information_to_display: 'Göstəriləcək məlumat yoxdur.',
    unzipping: 'Açılır...',
    saving: 'Saxlanılır',
    loading_stores: 'Mağazalar yüklənir...',
    getting_stores: 'Mağazalar əldə edilir...',
    request_has_failed: 'Maksimum təkrar cəhd sayı çatdı. Sorğu uğursuz oldu.',
    a_few_minutes: 'Mağazalar yüklənir...\nBu proses bir neçə dəqiqə çəkə bilər.',
    //nuevos al 27-01-2015
    assets_download_completed: 'Perfect Store resurslarının yüklənməsi tamamlandı',
    perfect_store_download: 'Perfect Store uğur şəkli yüklənməsi tamamlandı',
    perfect_store_error: 'Perfect Store resurslarının yüklənməsində xəta baş verdi',
    connection_interrupted: 'Əlaqə kəsildi, əlaqə bərpa edildikdən sonra uğur şəkli açılacaq',
    decompressing_perfect_store: 'Mükəmməl Mağaza endirilir',
    downloading_perfect_store: 'Mükəmməl Mağaza yüklənir',
    saving_perfect_store: 'Mükəmməl Mağaza saxlanılır',
    remain_downloaded: '\nYüklənməli qalan ',
    assets: ' resurslar.',
    download_complete: 'Yükləmə tamamlandı.',

    //Portfolio
    no_brands_to_show: 'Göstərmək üçün brendlər yoxdur',
    no_products_to_show: 'Göstərmək üçün məhsullar yoxdur',
    try_again_later: 'Daha sonra yenidən cəhd edin',
    portfolio: 'Portfel',
    select_one: 'Məhsullarını və xidmətlərini görmək üçün brendlərdən birini seçin.',
    learn_about: 'App-də bizim məhsullar və xidmətlərin tam diapazonunu öyrənin.',
    //nuevos al 01-08-2024
    brand: 'Marka',
    description: 'Təsvir',
    ingredients: 'Tərkibi',
    data_sheet: 'Texniki vərəq',

    //Benefits
    points_can_be_exchanged: 'Aşağıdakılər üçün mübadilə edilə bilər:',
    approved: 'Təsdiqlənmiş',
    cancelled: 'Ləğv edildi',
    pending: 'Gözləyən',
    redeemed: 'QULLUQ EDİLƏN',
    added_points: 'Balin Əlavə olunması',
    all: 'Hamısı',
    my_points: 'Mənim balım',
    your_points: 'Sizin balınız',
    delivered: 'Təhvil verilib',
    no_benefits: 'Hələlik heç bir yarar yoxdur',
    add_points: 'Mübadilə etmək üçün balınızı qazanın',
    no_history: 'Hələlik heç bir tarix yoxdur',
    redeem_your_points: 'Balınızı mübadilə edin və tarixinizdən sonra tarixinizi görsədə bilərsiniz',
    pending_approval: 'Təsdiq gözləyir',
    when_it_is_approved: 'Təsdiqləndikdən sonra tarixinizdə görünəcək',
    unredeemed_benefit: 'Qulluq edilməmiş yarar',
    you_dont_have_enough_points: 'Bu yararın mübadilə edilməsi üçün kifayət qədər balınız yoxdur',
    accept: 'Qəbul et',
    units_available: ' mövcud vahid',
    redeem_benefit: 'Faydayı mübadilə edin',
    benefits_mayus: 'YARARLAR',
    history: 'TARİX',
    there_was_a_mistake: 'Səhv oldu',

    //Vouchers
    complete_to_redeem_the_voucher: 'Qaiməni qəbul etmək üçün tamamlayın',
    valid_until: 'İndiyədək etibarlıdır: ',
    quantity_purchased: 'Alınan miqdar: ',
    redeem: 'Qaiməni qəbul etmək',
    lumps: 'Lumps',
    voucher_redeemed: 'Qaimə müvəffəqiyyətlə qəbul edildi',
    error_redeeming_voucher: 'Qaiməni qəbul etdikdə səhv oldu. Yenidən cəhd edin.',
    validate_and_redeem_vouchers: 'Qaimələri təsdiq edin və qəbul edin',
    to_get_started: 'Başlamaq üçün, kameranızla Qaimənin QR-ni daxil edin və ya skan edin',
    write_your_code: 'Kodunuzu yazın...',
    validate: 'Təsdiq edin',
    back_to_store: 'Mağazaya qayıdın',
    scan_qr: 'QR kodu skan edin',
    scan_on_the_voucher: 'Başlamaq üçün, kuponun QR kodunu skan edin',
    view_history: 'Tarixi göstər',
    voucher_history: 'Kupon tarixi',
    voucher_history_description:
        'Bu tarix sizə edilən dəyişiklikləri dəqiq izləməyə imkan verir, yığılmış mükafatlarınızın izlənməsi və idarə olunmasını asanlaşdırır.',
    see_more: 'Daha çox göstər',
    see_less: 'Daha az göstər',

    //Faltantes
    upload_image: 'Şəkil yüklə',
    uploaded_image: 'Yüklənmiş şəkil',
    photo: 'Foto',
    edit: 'Redaktə et',
    delete: 'Sil',
    enter_a_comment: 'Şərh yazın',
    enter_a_value: 'Dəyər daxil edin',
    want_to_check_out: 'Çıxış etmək istədiyinizə əminsinizmi?',
    not_check_in_again: 'Bir dəfə təsdiqləndikdən sonra növbəti ziyarətinizə qədər yenidən qeydiyyatdan keçə bilməyəcəksiniz.',

    //Alert
    alert: 'Xəbərdarlıq',
    enter_characters: 'Prefiksdən sonra 10 simvol daxil etməlisiniz',
    numerical_field: 'Dəyişdirilən sahə rəqəmsal olmalıdır, boşluqlar və hərflər olmadan.',
    enter_date_of_birth: 'Doğum tarixini YYYY-MM-DD formatında düzgün daxil edin.',
    session_expired: 'Sessiya bitdi',
    your_session_has_expired: 'Sessiyanız bitdi. Zəhmət olmasa yenidən cəhd edin.',
    error: 'Xəta',
    error_occurred: 'Şifrəni dəyişməyə çalışarkən xəta baş verdi.',
    email_verification_code_incorrect: 'E-poçt təsdiq kodu yanlışdır.',
    phone_verification_code_incorrect: 'Telefon təsdiq kodu yanlışdır.',
    no_checkin_found: 'Çekin tapılmadı.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
